import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import jsonwebtoken from 'jsonwebtoken';
import moment from 'moment';
import FormMixin from '../vue_mixins/FormMixin';
import { JWT_HMAC_SECRET } from '../constants/app';
let RecaptchaMixin = class RecaptchaMixin extends Mixins(FormMixin) {
    constructor() {
        super(...arguments);
        this.robot = false;
    }
    get captchaSiteKey() {
        return process.env.VUE_APP_CAPTCHA_KEY || '';
    }
    get isRobot() {
        return this.robot;
    }
    get captchaPayload() {
        let timestamp = moment().unix();
        let captchaKey = this.captchaSiteKey;
        if (this.isRobot) {
            timestamp = 0;
            captchaKey = '';
        }
        return { captchaKey, timestamp };
    }
    get jwtCaptcha() {
        return jsonwebtoken.sign(this.captchaPayload, `${JWT_HMAC_SECRET}`);
    }
    recaptchaErrorNotifier(message = 'Please confirm recaptcha') {
        this.errorNotification(message);
        // this.resetRecaptcha();
        this.requestDone();
    }
    resetRecaptcha(id = null) {
        if (id) {
            window.grecaptcha.reset(id);
        }
        else {
            window.grecaptcha.reset();
        }
        this.robot = true;
    }
};
RecaptchaMixin = __decorate([
    Component
], RecaptchaMixin);
export default RecaptchaMixin;
